import { IDataCollectionMap } from "./types";

export function GetArrayDataCollectionList(dataArray: Array<any>): IDataCollectionMap[] {
    let dataResult: IDataCollectionMap[] = [];
    dataArray?.map((rowContent, rowID) => (
        dataResult.push({ Data: rowContent, dataID: rowID })
    ));
    return dataResult;
}
export function GetArrayDataCollectionListMC(dataArray: Array<any>): IDataCollectionMap[] {
    let dataResult: IDataCollectionMap[] = [];

        //indiceaverage, dataaverage, horainiaverage, horafimaverage
    dataArray?.map((rowContent, rowID) => (
        dataResult.push({ Data: [rowContent.av, rowContent.indice, rowContent.baseAverage, 
            rowContent.dataRating.split('T')[0] + "|" + rowContent.minutos.replaceAll(" ","").split("-")[0] 
            + "|" + rowContent.minutos.replaceAll(" ","").split("-")[1]] , dataID: rowID  })

    ));
    return dataResult;
}


export function GetArrayDataMC(dataArray: Array<any>): IDataCollectionMap[] {
    let dataResult: IDataCollectionMap[] = [];



    dataArray?.map((rowContent, rowID) => (

        dataResult.push({ Data: [rowContent.av, rowContent.indice, rowContent.baseAverage, AjusteDataFormat(rowContent.dataRating, rowContent.minutos), ...retDadosArray(rowContent.ListDados)], dataID: rowID })

    ));
    return dataResult;
}

function AjusteDataFormat(dataFull: string, minutos: string) {

    let dataSplit = dataFull.split("T")[0];
    let [year, month, day] = dataSplit.split('-');
    let formattedDate = `${day}-${month}-${year}`;


    let ret: string = " " + formattedDate + " " + minutos;
    return ret;
}
function retDadosArray(listDados) {

    if (listDados.length == 1) {
        return listDados[0];
    } else {
        let linhaUnica: string[] = [];
        for (let i = 0; i < listDados[0].length; i++) {
            // Combina os elementos correspondentes com '|'
            linhaUnica.push(`${listDados[0][i]}|${listDados[1][i]}`);
        }
        return linhaUnica;

    }
}